import React, { useEffect, useState } from "react";
import "./resume.css";
import { Col, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import ResumeBuilderForm from "./ResumeBuilderForm";
import classes from "./styles.module.css";
import SectionSidebar from "./SectionSidebar";
import ChooseResumeTemplates from "./ChooseResumeTemplates";
import ResumePreviewAndDownload from "./ResumePreviewAndDownload";

function classnames(obj) {
  return Object.entries(obj)
    .filter(([key, value]) => value)
    .map(([key]) => key)
    .join(" ");
}

const ResumeBuilder = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [activeSection, setActiveSection] = useState("section1");

  useEffect(() => {
    window.scrollTo({ top: 50, behavior: "smooth" });
  }, []);

  const tabChange = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div className={`custom-container container-fluid ${classes.mainSec}`}>
      <div className="main-resume-container">
        <h3 className="text-center mb-5">Resume Builder</h3>

        <Nav
          tabs
          className="job-list-menu nav-pills nav-justified flex-column flex-sm-row mb-4"
          id="resume-tabs"
          role="tablist"
        >
          <NavItem role="presentation">
            <NavLink
              className={classnames({ active: activeTab === "1" })}
              onClick={() => tabChange("1")}
              id="edit-resume-tab"
              type="button"
              role="tab"
            >
              <i className="mdi mdi-pencil-outline me-2"></i>
              Edit Resume
            </NavLink>
          </NavItem>
          <NavItem role="presentation">
            <NavLink
              className={classnames({ active: activeTab === "2" })}
              onClick={() => tabChange("2")}
              id="choose-template-tab"
              type="button"
              role="tab"
            >
              <i className="mdi mdi-file-document-edit-outline me-2"></i>
              Choose Template
            </NavLink>
          </NavItem>
          <NavItem role="presentation">
            <NavLink
              className={classnames({ active: activeTab === "3" })}
              onClick={() => tabChange("3")}
              id="preview-download-tab"
              type="button"
              role="tab"
            >
              <i className="mdi mdi-eye-outline me-2"></i>
              Preview &amp; Download
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <Row>
              <Col lg={3}>
                <SectionSidebar
                  setActiveSection={setActiveSection}
                  activeSection={activeSection}
                />
              </Col>
              <Col lg={9}>
                <ResumeBuilderForm
                  activeSection={activeSection}
                  setActiveSection={setActiveSection}
                   setActiveTab={setActiveTab} 
                />
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="2">
            <ChooseResumeTemplates />
          </TabPane>
          <TabPane tabId="3">
            <ResumePreviewAndDownload />
          </TabPane>
        </TabContent>
      </div>
    </div>
  );
};

export default ResumeBuilder;
